import { type FC } from 'react'

import { useDraggable } from '@dnd-kit/core'
import styled from '@emotion/styled'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { shouldForwardProp } from '../../helpers/styled.ts'

import { StyledWidgetListItem } from './FormBuilder.styles.ts'

interface StyledContainerProps {
  height: number | undefined
}

const StyledContainer = styled('div', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<StyledContainerProps>(['height'], prop),
})<StyledContainerProps>`
  border-radius: 3px;
  background-color: #f7f7f7;

  //padding-right: 20px;

  //overflow: hidden;

  ${({ height }) =>
    height !== undefined
      ? `
  height: ${height - 41}px;`
      : ''}

  .scrollbar-container {
    padding-left: 16px;
    // &.ps {
    //   padding-right: 0px;
    // }

    & .ps__rail-y {
      cursor: pointer;
      background-color: #e9e9e9;
      width: 12px;
      .ps__thumb-y {
        width: 6px;
      }
    }
  }
`

const StyledDescription = styled.p`
  padding-top: 16px;
  margin-bottom: 12px;
  color: #7c7c7c;
  font-style: italic;
`

const StyledWidgetsList = styled.ul`
  padding-bottom: 16px;
`

interface Widget {
  component: string
  renderStageComponent: (c: any) => any
  defaultConfig: (c: any) => any
}

interface FormBuilderToolboxProps {
  height: number | undefined
  className?: string
  'data-mu-test'?: string
  title?: string
  description?: string
  options: Widget[]
  globalDefaults: any
}

interface DraggableItemProps {
  item: Widget
  globalDefaults: any
}

const DraggableItem: FC<DraggableItemProps> = ({ item, globalDefaults }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    //  isDragging
  } = useDraggable({
    id: item.component,
    data: {
      type: 'toolbox',
      fromToolbox: true,
    },
  })

  return (
    <StyledWidgetListItem
      isDragging={false}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
    >
      {item.renderStageComponent(item.defaultConfig(globalDefaults))}
    </StyledWidgetListItem>
  )
}

const PerfScrollbar = PerfectScrollbar as unknown as React.ElementType

export const FormBuilderToolbox: FC<FormBuilderToolboxProps> = ({
  height,
  className,
  'data-mu-test': dataAttributeTest,
  title,
  description,
  options,
  globalDefaults,
}) => {
  return (
    <StyledContainer
      className={className}
      data-mu-test={dataAttributeTest}
      height={height}
    >
      <PerfScrollbar>
        {description !== undefined && (
          <StyledDescription>{description}</StyledDescription>
        )}

        <StyledWidgetsList>
          {options.map((item) => (
            <DraggableItem
              item={item}
              globalDefaults={globalDefaults}
              key={item.component}
            />
          ))}
        </StyledWidgetsList>
      </PerfScrollbar>
    </StyledContainer>
  )
}
